<template>
    <div class="payment">
        <div v-if="hotelRooms !== undefined && hotelRooms !== null && !hotelRooms.length && registerType === 'hotels'">
            Brak dostępnych hoteli
        </div>
        <div v-if="!content">

            <div class="row">
                <!--                Radio z formą udziału-->
                <div class="user-type-section col-md-4 col-sm-12">
                    <div class="form-check mb-1">
                        <input id="userOnline" v-model="type" class="form-check-input" type="radio" value="online"
                               @change="attendanceType(false)">
                        <label class="form-check-label" for="userOnline"> Udział online </label>
                    </div>
                    <div class="form-check mb-0">
                        <input id="userOffline" v-model="type" class="form-check-input" type="radio"
                               value="offline" @change="attendanceType(true)">
                        <label id="userOfflineLabel" class="form-check-label" data-bs-placement="top"
                               data-bs-toggle="tooltip"
                               for="userOffline"> Udział stacjonarny </label>
                    </div>
                </div>

                <!--                Hotele - Nie dotyczy FIT-->
                <!--                <div v-if="registerType === 'hotels' && this.type === 'offline'" class="col-md-4 col-sm-12">-->
                <!--                    <div class="col-sm-12">-->
                <!--                        <div class="form-row">-->
                <!--                            <label class="text-white">Hotel</label>-->
                <!--                            <select v-model='hotelRoom' class='custom-select' @change="setHotelRoom">-->
                <!--                                <option disabled selected value="">Wybierz rekord</option>-->
                <!--                                <option v-for='hotelRoom in hotelRooms' :value='hotelRoom'>{{ hotelRoom.hotel_name }} - -->
                <!--                                    {{ hotelRoom.name }}-->
                <!--                                </option>-->
                <!--                            </select>-->
                <!--                        </div>-->
                <!--                        <div v-if="hotelRoom">-->
                <!--                            <div v-for="(companion, index) in companions" class="form-row mt-1">-->
                <!--                                <input :key="index"-->
                <!--                                       v-model="companion.value" class="form-control"-->
                <!--                                       placeholder="Imię i nazwisko współlokatora" type="input"-->
                <!--                                       @change="checkCompanion(companion, index)">-->
                <!--                                <div v-if="companion.status == 'already_filled'" class="text-danger">Współlokator jest-->
                <!--                                    już przypisany do innego uczestnika-->
                <!--                                </div>-->
                <!--                                <div v-if="companion.status == 'not_exist'" class="text-danger">Taki współlokator nie-->
                <!--                                    istnieje.-->
                <!--                                </div>-->
                <!--                                <div v-if="companion.status == 'registered_to_other_room'" class="text-danger">Taki-->
                <!--                                    współlokator zapisał się do innego pokoju.-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div v-if="registerType === 'hotels' && this.type === 'offline'" class="col-md-4 col-sm-12 text-left">-->
                <!--                    <label class="text-white">Noclegi</label>-->
                <!--                    <div v-for="eventDate in eventDates" class="form-check mb-1">-->
                <!--                        <input :id="eventDate.date" v-model="eventDate.checked" :value="eventDate"-->
                <!--                               class="form-check-input"-->
                <!--                               type="checkbox" @change="setPrice">-->
                <!--                        <label :for="eventDate.date" class="form-check-label">{{ eventDate.date }}-->
                <!--                            <div v-if="eventDate.is_required" class="required-date">(nocleg obowiązkowy)</div>-->
                <!--                        </label>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>

            <!-- Customizable Form-->
            <div v-if="customizableFormDisplay">
                <div
                    v-for="(form, index) in formFields.fields.filter((form => !form.inputType || form.inputType==='checkbox'))"
                    class="row mt-3 text-white">
                    <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12">
                        <!--Input  -->
                        <!--                            v-if="!form.inputType || form.inputType === 'checkbox' && isRequiredInputChecked(form.condition)"-->
                        <div
                            v-if="(!form.inputType || form.inputType === 'checkbox') && (!form.visible || form.visible === '1') && isConditionInputChecked(form.name)"
                            class="row align-items-center  text-md-right text-sm-left pb-3">
                            <label
                                :class="form.disabled === '1' ? 'disabled-form-label col-10 mb-0' : 'col-10 mb-0'"
                                :for="form.name.split(' ').join('-').toLowerCase() + '-checkbox'">
                                <h5 class="mb-0" v-html="form.name"></h5>
                            </label>
                            <!--                            :disabled="isFieldTrue(form.name, 'with_companion')"-->
                            <input :id="form.name.split(' ').join('-').toLowerCase() + '-checkbox'"
                                   :disabled="form.disabled && form.disabled === '1'"
                                   class="form-control col form-check-input-reverse col-1"
                                   type="checkbox"
                                   @change="setPrice"
                                   @input="setFormField(form.name, 'does_attend', $event.target.checked)">
                        </div>
                        <!--                        <div v-else-if="form.inputType === 'radio'"-->
                        <!--                             class="row align-items-center  text-md-right text-sm-left pb-3">-->
                        <!--                            <label class="col-10 mb-0">-->
                        <!--                                <h5 class="mb-0" v-html="form.name"></h5>-->
                        <!--                            </label>-->
                        <!--                            <input :disabled="isFieldTrue(form.name, 'with_companion')"-->
                        <!--                                   :name="form.group"-->
                        <!--                                   class="form-control col form-check-input-reverse col-1"-->
                        <!--                                   type="radio"-->
                        <!--                                   @change="setPrice"-->
                        <!--                                   @input="setFormField(form.name, 'does_attend', $event.target.checked)">-->
                        <!--                        </div>-->

                        <!-- Wyświetlenie checkboxa Osoba Towarzysząca, gdy powyższe pole jest zaznaczone -->
                        <div v-if="isFieldTrue(form.name, 'does_attend') && isFieldTrue(form.name, 'companion_allowed')"
                             id="companion"
                             class="row align-items-center  text-md-right text-sm-left pb-3">
                            <label :for="form.name.split(' ').join('-').toLowerCase() + '-checkbox-companion'"
                                   class="col-10 mb-0"><h5 class=" mb-0">Osoba towarzysząca</h5></label>
                            <input :id="form.name.split(' ').join('-').toLowerCase() + '-checkbox-companion'"
                                   class="form-control col form-check-input-reverse col-1"
                                   type="checkbox"
                                   @change="setPrice"
                                   @input="setFormField(form.name, 'with_companion', $event.target.checked)">
                        </div>

                        <!-- Wyświetlenie input.text, gdy powyższe pole jest zaznaczone -->
                        <div v-if="isFieldTrue(form.name, 'with_companion')" class="form-row">
                            <input placeholder="Imię i nazwisko" size="col-md-6" type="text"
                                   @input="setFormField(form.name, 'companion_name', $event.target.value)">
                        </div>
                        <!--                        <hr v-if="index != Object.keys(formFields.fields).length - 1" class="my-4"-->
                        <!--                            style="background-color: white;">-->
                    </div>
                </div>

                <hr class="my-4" style="background-color: white;">
            </div>


            <div class="row">
                <div class="coupon-section col-md-4 col-sm-12">
                    <input v-model="code" placeholder="Mam kod rabatowy" v-on:change="setPrice">
                    <h5>Cena: <span v-html="amount"></span>zł brutto</h5>
                    <h5>Rabat: <span v-html="discountValue"></span>zł brutto</h5>
                </div>

                <div class="payment-method-section col-md-4 col-sm-12">
                    <h4>Forma płatności</h4>
                    <div v-if="this.amount > 0" class="form-check mb-1">
                        <input id="przelewy24" v-model="paymentMethod" class="form-check-input" type="radio" value="1">
                        <label class="form-check-label" for="przelewy24"><img class="przelewyLogo"
                                                                              v-bind:src="getAssetPath('/images/przelewy24_logo.svg')"/></label>
                    </div>
                    <div v-if="this.amount > 0" class="form-check mb-0">
                        <input id="przelew" v-model="paymentMethod" class="form-check-input" type="radio" value="2">
                        <label class="form-check-label" for="przelew">Przelew bankowy</label>
                    </div>
                </div>
            </div>

            <hr class="mt-2 mb-5" style="background-color: white;">

            <div class="row">
                <div class="col-sm-12">
                    <div v-if="agreementInputs.length != 0">
                        <form-agreement-input v-model="agreements" :agreementInputs="agreementInputs"
                                              :error-messages="errorMessages"></form-agreement-input>
                    </div>
                </div>

                <hr class="my-4 col-11" style="background-color: white;">

                <div class="offset-md-1 offset-sm-0 col-md-10 col-sm-12">
                    <div class="price-section">
                        <h3>Cena finalna: <span v-html="amount"></span>zł brutto</h3>
                        <h5>Faktura zostanie wysłana automatycznie po otrzymaniu płatności</h5>
                        <!--                        <h5 class="mb-4 mt-3"> Sprawdź aktualność <a class="data-info-link" target="_blank"-->
                        <!--                                                                     v-bind:href="profile_url"> swoich danych </a> przed-->
                        <!--                            przejściem do płatności. </h5>-->
                        <h5 class="mb-4 mt-3"><span style="color: crimson; font-weight: 700">Uwaga!</span> Przed
                            przejściem do płatności
                            sprawdź
                            aktualność <a class="data-info-link" target="_blank"
                                          v-bind:href="profile_url"> swoich danych </a>.<br>
                            Możesz to zrobić klikając <a :href="profile_url" class="data-info-link"
                                                         style="font-weight: 700">tutaj</a>
                        </h5>

                        <button :disabled="isDisabled" v-on:click="handlePaymentForm">
                            <span v-if="this.amount > 0">Przejdź do płatności</span>
                            <span v-else>Potwierdź</span>
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <div class="bank-transfer text-white" v-html="content"></div>
        <notifications group="foo"/>

    </div>


</template>
<script>
import FormAgreementInput from "./formAgreementInput";

export default {
    props: ['event_id', 'price', 'asset_path', 'profession', 'profile_url', 'register_type'],

    components: {
        FormAgreementInput,
    },

    data() {
        return {
            paymentMethod: null,
            amount: this.price,
            profession: this.profession,
            code: null,
            discountValue: 0,
            content: null,
            customizableFormData: [],
            formFields: [],
            agreements: [],
            agreementInputs: [],
            errorMessages: [],
            numberOfRequireInputes: 0,
            isDisabled: false,
            type: 'offline',
            customizableFormDisplay: true,
            hotelRooms: [],
            hotelRoom: null,
            eventDates: [],
            companions: [],
            registerType: this.register_type
        }
    },
    beforeMount() {
        axios.get('/api/agreements', {
            params: {
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
            }
        }).then(response => {
            this.agreementInputs = response.data.data;
        });

        axios.get('/api/hotel-rooms', {
            params: {
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
            }
        }).then(response => {
            this.hotelRooms = response.data.data;
        });

        axios.get('/api/eventables/get-dates', {
            params: {
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
            }
        }).then(response => {
            this.eventDates = response.data;
        });

        axios.get('/api/customizable-forms', {
            params: {
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
            }
        }).then(response => {
            this.formFields = response.data.data;
            // console.log(response.data.data);
            var newFormData = [];
            this.formFields.fields.forEach(function (item, index) {
                newFormData[index] = {
                    form_name: item.name,
                    with_companion: false,
                    companion_allowed: item.companion_allowed === '1' ? true : false,
                    does_attend: item.name === 'Udział stacjonarny',
                    companion_name: null,
                };
            });

            this.customizableFormData = newFormData;
        });

        this.setPrice();

    },
    afterMount() {
        this.attendanceType(true);
        this.type = 'offline';
        this.updateAttendanceTypeCustomizableFormField('offline')

    },
    methods: {
        checkCompanion(companion, index) {
            if (companion.value == '') {
                this.$set(companion, 'status', 'ready_to_fill');
            } else {
                axios.post('/api/check-companion', {
                    eventableId: this.event_id,
                    eventableType: 'App\\Models\\Event',
                    hotelRoom: this.hotelRoom,
                    companion: companion.value
                })
                    .then(response => {
                        // console.log(response.data);
                        this.$set(companion, 'status', response.data);
                        let msg = '';
                        if (response.data == 'already_filled') {
                            msg = 'Wybrany uczestnik jest już zakwaterowany z inną osobą. Prosimy skontaktować się z organizatorem.';
                        } else if (response.data == 'not_exist') {
                            msg = 'Wybrany uczestnik nie istnieje';
                        } else if (response.data == 'registered_to_other_room') {
                            msg = 'Wybrany uczestnik zapisał się do innego pokoju';
                        }

                        if (msg != '') {
                            this.$notify({
                                'group': 'foo',
                                'type': 'error',
                                'title': msg,
                            });
                        }
                    })
                    .catch(error => {
                        var errors = error.response.data.errors;
                        Object.values(errors).forEach(singleError => {
                            this.$notify({
                                'group': 'foo',
                                'type': 'error',
                                'title': singleError[0]
                            });
                        });
                    });
            }
        },
        setHotelRoom() {
            this.companions = [];
            for (let i = 0; i < this.hotelRoom.person_limit - 1; i++) {
                this.companions.push({value: '', hasError: false});
            }
            this.setPrice();
        },
        geNumberOfRequireInputes() {
            for (let i = 0; i < this.agreementInputs.length; i++) {
                if (this.agreementInputs[i].active == 1 && this.agreementInputs[i].required == 1) {
                    this.numberOfRequireInputes++;
                }
            }
        },
        handlePaymentForm() {
            this.isDisabled = true;

            if (this.companions.length > 0) {
                const hasCompanionErrors = this.companions.some(companion => companion.status === 'already_filled' || companion.status === 'not_exists');

                if (hasCompanionErrors) {
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': 'Wystąpiły błędy w danych współlokatorów'
                    });

                    this.isDisabled = false;
                    return false;
                }
            }

            if (this.paymentMethod === null && this.amount !== 0) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać metodę płatności'
                });
                this.isDisabled = false;
                return false;
            }

            if (this.hotelRoom === null && this.registerType === 'hotels' && this.type === 'offline') {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać hotel'
                });

                this.isDisabled = false;
                return false;
            }
            if (this.type === 'offline') {
                if (this.eventDates.some(eventDate => eventDate.is_required && !eventDate.checked)) {
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': 'Proszę zaznaczyć wymagane daty'
                    });

                    this.isDisabled = false;
                    return false;
                }
            }

            if (this.agreementInputs.length != 0) {
                this.geNumberOfRequireInputes();
                if (this.agreements.filter(Boolean).length < this.numberOfRequireInputes) {
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': 'Prosimy zaznaczyć wszystkie wymagane zgody'
                    });
                    this.numberOfRequireInputes = 0;
                    this.isDisabled = false;
                    return false;
                }
                this.numberOfRequireInputes = 0;
            }

            if (this.type === 'online') {
                // this.customizableFormData = [];
                // this.setFormField(formName, inputName, value)
                // this.formFields.fields[0].name
                this.customizableFormData.forEach((form, index) => {
                    if (form.form_name === 'Udział online') {
                        this.customizableFormData[index].does_attend = true;
                    } else {
                        this.customizableFormData[index].does_attend = false;
                    }
                });
            }

            axios.post('/api/payment/create', {
                paymentMethod: this.paymentMethod,
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
                code: this.code,
                amount: this.amount,
                agreements: this.agreements,
                customizableFormData: this.customizableFormData,
                type: this.type,
                hotelRoom: this.hotelRoom,
                eventDates: this.eventDates,
                companions: this.companions,
            })
                .then(response => {
                    let data = response.data.data;
                    if (data.redirect_panel) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = '/profil';
                        }, 1500);
                    }
                    if (data.url) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = data.url;
                        }, 1500);
                    }
                    if (data.content) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });
                        this.content = data.content;
                        this.content += '</br></br> Kwota do zapłaty: ' + data.payment['amount'] + 'zł';
                    }
                })
                .catch(error => {
                    this.isDisabled = false;
                    var errors = error.response.data.errors;
                    Object.values(errors).forEach(singleError => {
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': singleError[0]
                        });
                    });
                });
        },
        setFormField(formName, inputName, value) {
            // console.log(this.customizableFormData);
            // console.log(this.formFields);
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            })

            if (existIndex === -1) {
                var newIndex = this.customizableFormData.length;
                var newArray = {
                    form_name: formName
                };
                newArray[inputName] = value;
                this.$set(this.customizableFormData, newIndex, newArray);
            } else {
                var newArray = this.customizableFormData[existIndex];
                newArray[inputName] = value;
                this.$set(this.customizableFormData, existIndex, newArray);
            }

        },
        isFieldTrue(formName, inputName) {
            const existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });
            if (existIndex === -1) {
                return false;
            }
            return !!(this.customizableFormData[existIndex][inputName] && this.customizableFormData[existIndex][inputName] === true);
        },
        hasCondition(formName) {
            const existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });
            // console.log('condition index = ' + existIndex, 'this.customizableFormData[existIndex]:');
            // console.log(this.customizableFormData[existIndex]);
            const output = this.customizableFormData[existIndex]['condition'] && this.customizableFormData[existIndex]['condition'] !== '0';
            // console.log('this.customizableFormData[existIndex][\'condition\'] = ' + this.customizableFormData[existIndex]['condition']);
            // console.log('hasCondition(' + formName + '), output = ' + output);
            return output;
        },
        isConditionInputChecked(formName) {
            const currentIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });
            // console.log('customizableFormData[' + currentIndex + '].form_name=' + this.customizableFormData[currentIndex].form_name);

            // Check if there is corresponding form name in form scheme
            if (!this.customizableFormData[currentIndex].form_name === this.formFields.fields[currentIndex].name) {
                // console.log('there is no corresponding form name in form scheme');
                return true;
            }
            // console.log('formFields.fields[' + currentIndex + '].name=' + this.formFields.fields[currentIndex].name);

            // Check if condition field is undefined or it has been set without condition
            if (!this.formFields.fields[currentIndex].condition || this.formFields.fields[currentIndex].condition === '0') {
                // console.log('Condition field is undefined or 0');
                return true;
            }

            // Check if there is corresponding form name to condition value
            const conditionFieldIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === this.formFields.fields[currentIndex].condition;
            })
            if (conditionFieldIndex === -1) {
                // console.log('there is no corresponding form name for that condition name');
                return true;
            }
            // console.log('customizableFormData[' + conditionFieldIndex + '].form_name=' + this.customizableFormData[conditionFieldIndex].form_name);

            // Check if corresponding form name has been checked
            return this.customizableFormData[conditionFieldIndex].does_attend;
        },
        updateAttendanceTypeCustomizableFormField(type = 'offline') {
            // console.log('updateAttendanceTypeCustomizableFormField(' + type + ')');
            const offlineIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === 'Udział stacjonarny';
            });
            const onlineIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === 'Udział online';
            });
            // console.log('offlineIndex = ' + offlineIndex + 'onlineIndex = ' + onlineIndex);

            if (type === 'online') {
                if (offlineIndex !== -1) {
                    this.customizableFormData[offlineIndex]['does_attend'] = false;
                }
                if (onlineIndex !== -1) {
                    this.customizableFormData[onlineIndex]['does_attend'] = true;
                }
                // console.log('type = online, offline=' + this.customizableFormData[offlineIndex]['does_attend'] + ', online=' + this.customizableFormData[onlineIndex]['does_attend']);
            } else {
                if (offlineIndex !== -1) {
                    this.customizableFormData[offlineIndex]['does_attend'] = true;
                }
                if (onlineIndex !== -1) {
                    this.customizableFormData[onlineIndex]['does_attend'] = false;
                }
                // console.log('type != online, offline=' + this.customizableFormData[offlineIndex]['does_attend'] + ', online=' + this.customizableFormData[onlineIndex]['does_attend']);
            }
        },
        isFieldVisible(formName, inputName) {
            const existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                return false;
            }

            if (this.customizableFormData[existIndex][inputName] && this.customizableFormData[existIndex][inputName] === true) {
                return true;
            }
            return false;
        },
        setAgreement(e) {
            if (this.agreements.includes(e.target.value)) {
                var indexToDrop = this.agreements.indexOf(e.target.value);
                if (indexToDrop !== -1) {
                    this.agreements.splice(indexToDrop, 1);
                }
            } else {
                this.agreements.push(e.target.value);
            }
        },
        setPrice() {
            axios.post('/api/prices', {
                customizableFormData: this.customizableFormData,
                code: this.code,
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
                type: this.type,
                eventDates: this.eventDates,
                hotelRoom: this.hotelRoom,
            }).then(response => {
                this.amount = response.data.data.price;
                this.discountValue = response.data.data.discountValue;
            }).catch(error => {
                this.amount = response.data.data.price;
                this.discountValue = 0;
                if (error.response.data.errors.code) {
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.errors.code[0]
                    });
                }
            });
        },
        attendanceType(display) {
            // console.log('attendanceType(' + display + ')');
            // Clear checked customizable form data when switching to online
            if (!display) {
                console.log(this.customizableFormData);
                this.customizableFormData.forEach(obj => {
                    obj.does_attend = false;
                    obj.with_companion = false;
                });
            }

            this.setPrice();
            this.customizableFormDisplay = display;
            // console.log('this.customizableFormDisplay = ' + display);
            this.updateAttendanceTypeCustomizableFormField(display ? 'offline' : 'online');
            // this.formFields.fields[0].name
        },
        getAssetPath(path) {
            return this.asset_path + path;
        }
    }
}
</script>
<style>
.disabled-form-label {
    color: #ccc;
}
</style>
